import { useCallback, useRef, useState } from 'react';

export function useProductCardFocus<T = HTMLAnchorElement>() {
  const [focusIndex, setFocusIndex] = useState<number | undefined>(undefined);
  const itemRefs = useRef<Array<T | null>>([]);

  const setFocusToIndex = useCallback((index: number) => {
    setFocusIndex(index);
  }, []);

  const resetFocus = useCallback(() => setFocusIndex(undefined), []);

  return {
    focusIndex,
    setFocusToIndex,
    resetFocus,
    itemRefs,
  };
}
